import { Action } from 'js/components/ResourceEditProvider/ResourceEditContext';

type InitialState = {
  action: Action | null;
};

const initialState: InitialState = {
  action: null,
};

const uiDagReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'SET_ACTION':
      return {
        ...state,
        action: action.payload,
      };
    case 'CLEAR_ACTION':
      return {
        ...state,
        action: null,
      };
    default:
      return state;
  }
};

export { uiDagReducer };
